import { useSelector } from 'react-redux';
import { SlideOutWrapper } from './SlideOutWrapper';
import AccessoriesCard from '../accessories/AccessoriesCard.interstate';
import { UnsavedChangesConfirmationModal, useUnsavedChangesModal } from '@makemydeal/dr-dash-components';
import * as accessoriesSelectors from '@makemydeal/dr-dash-store/selectors/accessoriesSelectors';
import { FULL_SCREEN_SLIDE_OUT_WIDTH, getReturnToOfferButton } from '@makemydeal/dr-shared-ui-utils';
import type { SlideOutComponentProps } from '../../types';

export const AccessoriesSlideOut = ({ isOpen, onClose }: SlideOutComponentProps) => {
    const accessories = useSelector(accessoriesSelectors.getAccessoriesList);

    const {
        isDirtyRef: isAccessoriesFormDirtyRef,
        showConfirmationModal,
        handleClose,
        handleCancelChanges,
        handleContinueEditing
    } = useUnsavedChangesModal({
        savedData: accessories,
        onClose
    });

    return (
        <>
            <SlideOutWrapper
                title={'Accessories'}
                isOpen={isOpen}
                onClose={handleClose}
                panelWidth={FULL_SCREEN_SLIDE_OUT_WIDTH}
                testId="tab-slideout-accessories"
                footer={getReturnToOfferButton(handleClose)}
            >
                <AccessoriesCard
                    isInsideSlideOut
                    isAccessoriesFormDirtyRef={isAccessoriesFormDirtyRef}
                    shouldTriggerValidation={showConfirmationModal}
                />
            </SlideOutWrapper>
            <UnsavedChangesConfirmationModal
                show={showConfirmationModal}
                onCancelChanges={handleCancelChanges}
                onContinueEditing={handleContinueEditing}
            />
        </>
    );
};
